import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Billing / invoicing ServiceStores.
 *
 * `billing-capabilities` is find-only and takes no query, so it is offline-OFF:
 * the offline wrapper's blanket sync-on-reconnect is a bare find(), which is
 * fine here, but caching a capability report would let a stale "enabled" survive
 * a config change — exactly the thing the gate exists to prevent.
 */
export const billingStores: ServiceStoreConfig[] = [
  {
    name: "billing-capabilities",
    options: { idField: "id", enableStorage: false, enableOffline: false },
  },
  { name: "invoices", options: { idField: "id", enableStorage: false } },
  { name: "invoice-line-items", options: { idField: "id", enableStorage: false } },
  { name: "client-billing-profiles", options: { idField: "id", enableStorage: false } },
  { name: "recurring-invoices", options: { idField: "id", enableStorage: false } },
  { name: "recurring-line-items", options: { idField: "id", enableStorage: false } },
  // Blake's trackers (#3075 / #2663). Read by their pages and tabs, never at
  // boot. Writes go through the RAW Feathers service (a refusal must reach the
  // form, and ServiceStore.create caches what it returns).
  {
    name: "invoice-payments",
    options: { idField: "id", enableStorage: false, enableOffline: false, disableInitialFind: true },
  },
  // A keyed report like `client-overview`: get('all') or get(<client id>).
  {
    name: "ar-aging",
    options: {
      idField: "key",
      enableStorage: false,
      enableOffline: false,
      disableInitialFind: true,
      methods: ["get"],
      throwOnError: true,
    },
  },
  // Contract values are taken off by the API for anyone below admin/finance;
  // no copy of them is kept in the browser's storage either way.
  {
    name: "client-contracts",
    options: { idField: "id", enableStorage: false, enableOffline: false, disableInitialFind: true },
  },
];
